import { Controller } from '@hotwired/stimulus'

// Opens a <dialog> by ID when injected via Turbo Stream, then removes itself.
export default class extends Controller {
  static values = { dialogId: String }

  connect() {
    const dialog = document.getElementById(this.dialogIdValue)
    if (dialog && !dialog.open) dialog.showModal()
    setTimeout(() => this.element.remove(), 0)
  }
}
